import {
  fetchNotifications,
  fetchUnseenCount,
  updateAllNotifications,
  updateNotification,
} from '../routines/notificationRoutines';
import {
  ALL_NOTIFICATIONS,
  NOTIFICATION_CATEGORY_ID_TO_EVENT_MAP,
} from '../../common/constants/NotificationConstants';

const initialState = {
  isLoading: false,
  unseen: {
    task: 0,
    playbook: 0,
    entity: 0,
    email: 0,
    bulkUpdate: 0,
    all: 0,
    other: 0,
    ticket: 0,
  },
  task: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  playbook: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  email: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  entity: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  bulkUpdate: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  mentions: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  all: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  other: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
  ticket: {
    unseenOnly: false,
    lastId: null,
    hasMore: true,
    list: [],
  },
};

function getCategory(categoryId) {
  return NOTIFICATION_CATEGORY_ID_TO_EVENT_MAP[categoryId] || 'all';
}

function updateUnseenNotifications(notificationsToBeUpdated, data) {
  const updatedNotifications = [];

  notificationsToBeUpdated.forEach((notification) => {
    if (notification.id === data.id) {
      if (data.isSeen === false) {
        updatedNotifications.push({
          ...notification,
          isSeen: data.isSeen,
        });
      }
    } else if (notification.isSeen === false) {
      updatedNotifications.push(notification);
    }
  });

  return updatedNotifications;
}

function updateNotifications(notificationsToBeUpdated, data) {
  const updatedNotifications = [];
  notificationsToBeUpdated.forEach((notification) => {
    if (notification.id === data.id) {
      updatedNotifications.push({
        ...notification,
        isSeen: data.isSeen,
      });
    } else {
      updatedNotifications.push(notification);
    }
  });

  return updatedNotifications;
}

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case updateNotification.TRIGGER:
    case updateAllNotifications.TRIGGER:
    case fetchUnseenCount.TRIGGER:
    case fetchNotifications.TRIGGER: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case fetchNotifications.SUCCESS: {
      const { data, category, lastId, unseenOnly } = action.payload;
      const updatedState = { ...state };

      const prevId = updatedState[getCategory(category)].lastId;
      const prevNotifications = updatedState[getCategory(category)].list;

      const updatedNotifications = [];
      if (lastId) {
        updatedNotifications.push(...prevNotifications);
      }

      updatedNotifications.push(...data);

      updatedState[getCategory(category)] = {
        list: updatedNotifications,
        unseenOnly,
        lastId: data[data.length - 1]?.id || prevId,
        hasMore: data.length !== 0,
      };

      return {
        ...updatedState,
        isLoading: false,
      };
    }

    case updateAllNotifications.FAILURE:
    case updateNotification.FAILURE:
    case fetchUnseenCount.FAILURE:
    case fetchNotifications.FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case fetchUnseenCount.SUCCESS: {
      const { data } = action.payload;
      const updatedState = { ...state.unseen };
      let totalCount = 0;
      Object.values(data).forEach((unseenCount) => {
        updatedState[
          NOTIFICATION_CATEGORY_ID_TO_EVENT_MAP[unseenCount.category]
        ] = unseenCount.count;
        totalCount += unseenCount.count;
      });
      updatedState[ALL_NOTIFICATIONS] = totalCount;

      return {
        ...state,
        unseen: updatedState,
        isLoading: false,
      };
    }

    case updateNotification.SUCCESS: {
      const { category, unseenOnly, data } = action.payload;

      const notificationsToBeUpdated = [...state[getCategory(category)].list];
      let updatedNotifications;

      if (unseenOnly === true) {
        updatedNotifications = updateUnseenNotifications(
          notificationsToBeUpdated,
          data
        );
      } else {
        updatedNotifications = updateNotifications(
          notificationsToBeUpdated,
          data
        );
      }
      return {
        ...state,
        [getCategory(category)]: {
          ...state[getCategory(category)],
          list: [...updatedNotifications],
        },
      };
    }

    case updateAllNotifications.SUCCESS: {
      return { ...state };
    }

    default:
      return state;
  }
};

export default notificationReducer;
